import React from 'react';
import { Quote } from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const PHOTOS = [
  'https://images.unsplash.com/photo-1758691737605-69a0e78bd193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBvZmZpY2V8ZW58MHx8fHwxNzgxMjgwODk3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1573496130141-209d200cebd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBvZmZpY2V8ZW58MHx8fHwxNzgxMjgwODk3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/6809661/pexels-photo-6809661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
];

const Testimonials = () => {
  const { t } = useLanguage();
  return (
    <section
      id="testimonials"
      data-testid={SITE.sectionTestimonials}
      className="relative py-20 lg:py-32 bg-white"
    >
      <Container>
        <div className="max-w-2xl">
          <Reveal>
            <SectionEyebrow>{t.testimonials.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.testimonials.title}</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.testimonials.items.map((it, i) => (
            <Reveal key={it.author + i} delay={i * 0.08}>
              <article
                data-testid={SITE.testimonialCard}
                className="h-full bg-[#F7F8F5] rounded-2xl p-7 lg:p-8 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.3)] transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_18px_40px_-10px_rgba(0,166,81,0.18)] flex flex-col"
              >
                <div className="w-10 h-10 rounded-xl bg-[#00A651]/10 flex items-center justify-center">
                  <Quote size={18} className="text-[#00A651]" />
                </div>
                <p className="mt-5 text-[#0B0F0C] font-['Outfit'] text-lg leading-relaxed flex-1">
                  “{it.quote}”
                </p>
                <div className="mt-6 pt-6 border-t border-[rgba(0,166,81,0.12)] flex items-center gap-3">
                  <img
                    src={PHOTOS[i]}
                    alt=""
                    className="w-11 h-11 rounded-full object-cover ring-2 ring-white"
                  />
                  <div>
                    <div className="text-sm font-semibold text-[#0B0F0C]">{it.author}</div>
                    <div className="text-xs text-[#5C5C5C]">{it.role}</div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-8 text-xs text-[#5C5C5C]/70 italic">
            {t.testimonials.disclaimer}
          </p>
        </Reveal>
      </Container>
    </section>
  );
};

export default Testimonials;
